<template>
    <table class="fs-grid table" v-if="schema" x-columns-resizable>
        <thead>
            <tr>
                <th>
                    <div class="flex flex-end">
                        <i @click="addContext" class="fas fa-plus plus"></i>
                    </div>
                </th>
                <fs-head
                    ref="head"
                    v-for="(node,index) in activeBSheet"
                    :key="index"
                    :index="index"
                    :node="node"
                ></fs-head>
            </tr>
        </thead>
        <tbody>
            <fs-tree
                ref="row"
                v-for="(node,index) in schema"
                :key="node.id"
                :node="node"
                :index="index"
            ></fs-tree>
        </tbody>
    </table>
</template>

<script>
import FsTree from '@/components/FsTree.vue'
import FsHead from '@/components/FsHead.vue'
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'FsEditor',
    data() {
        return {
            scrollTop: 0,
            scrollLeft: 0,
        }
    },
    computed: {
        ...mapState(['schema','activeCell', 'companyCode']),
        ...mapGetters(['activeBSheet','fsCount','activeRow']),
    },
    watch: {
        activeCell: function(cell) {
            this.$refs.row[cell[0]].$refs.cell[cell[1]].$el.focus()
        },
        // when adding fs, re-focus the cell
        // try's block is to prevent error upon page reload
        fsCount: function() {
            try {
                console.log('watch fsCount')
                this.$refs.row[this.activeCell[0]].$refs.cell[this.activeCell[1]].$el.focus()
            } catch (err) {
                console.log('noop')
            }
        },
        $route(to, from) {
            console.log('xxx', to.params, from.params)
            this.$store.dispatch('fetchFsData', {
                endpoint: '/fs-data/'+to.params._id,
                state: 'fsData',
                force: true
            })
        }
    },
    created() {
        this.$store.dispatch('fetchSchema')
        this.$store.dispatch('fetchCalculation')
        this.$store.dispatch('fetchFormula')
        this.$store.dispatch('fetchAssertion')
        this.$store.dispatch('fetchFsData')

        if (this.$refs.row) {
            this.$refs.row[this.activeRow].$refs.cell[this.activeCell].$el.focus()
        }
        // window.addEventListener('scroll', this.handleScroll)
        let main = document.getElementById('main')
        main.addEventListener('scroll', () => {
            // console.log(main.scrollTop)
            this.scrollTop = main.scrollTop
        })
        // handle pageup/down
        document.getElementById('main').addEventListener('keydown', (e) => {
            if (e.key==='PageDown') {
                // get viewport height
                var vh = document.documentElement.clientHeight

                // check if active cell is at the last row on viewport
                var activeRow = document.getElementsByClassName('fs-tree')[this.activeRow].getBoundingClientRect()
                var gap = vh - activeRow.bottom
                if (gap >= 0 && gap < activeRow.height) {
                    // 
                } else {
                    e.preventDefault()
                    var rows = document.getElementsByClassName('fs-tree')
                    for (var i=rows.length-1; i>=0; i--) {
                        var boundRect = rows[i].getBoundingClientRect()
                        if (boundRect.bottom < vh) {
                            this.$store.dispatch('setActiveRow', i)
                            break
                        }
                    }
                }
            }
            if (e.key==='PageUp') {
                // get viewport height
                // var vh2 = document.documentElement.clientHeight

                // check if active cell is at the first row on viewport
                var activeRow2 = document.getElementsByClassName('fs-tree')[this.activeRow].getBoundingClientRect()
                // console.log(activeRow2)
                if (activeRow2.top >= 48 && (activeRow2.top - 48) < activeRow2.height) {
                    // active row is at very top row
                } else {
                    e.preventDefault()
                    var rows2 = document.getElementsByClassName('fs-tree')
                    for (var j=0; j < rows2.length; j++) {
                        var boundRect2 = rows2[j].getBoundingClientRect()
                        if (boundRect2.top > 48) {
                            this.$store.dispatch('setActiveRow', j)
                            break
                        }
                    }
                }
            }
        })
    },
    // beforeDestroy() {
    //     window.removeEventListener('scroll', this.handleScroll)
    // },
    methods: {
        fetchData: function () {
            this.$store.dispatch('fetchSchema')
        },
        handleScroll: function() {
            console.log('Y Offset:', window.pageYOffset)
        },
        addContext: function () {
            let payload = {
                timestamp: new Date(2019, 1, 1).getTime(),
                dateStart: '2019-01-01',
                dateEnd: '2019-12-31',
                lineItems: {},
                unsatisfied: [],
            }
            this.$store.dispatch('addNewFs', payload)
        },
    },
    components: {
        FsHead,
        FsTree,
    },
}
</script>

<style>
table.fs-grid {
    border-collapse: collapse;
}
table.fs-grid tbody th {
    text-align: left;
    font-weight: normal;
    padding-right: 1em;
    border: solid 1px #ccc;
}
.button {
    padding: 4px 10px;
    border: none;
    border-radius: 6px;
    background: linear-gradient(145deg, #e6e6e6, #ffffff);
    box-shadow:  3px 3px 6px #d9d9d9, 
                -3px -3px 6px #ffffff;
}
svg {
    fill: currentColor;
    cursor: pointer;
    color: lightblue;
}
.plus {
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-weight: bold;
    font-size: large;
    border-radius: 50px;
    color: #999;
}
.plus:hover {
    color: #333;
    background: #ddd;
    cursor: pointer;
}
</style>